import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('employee')

export class EmployeeEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id"
    })
    id: number

    @Column('varchar', {
        name: 'employee_name',
        nullable: true
    })
    employeeName: string;

    @Column('varchar', {
        name: 'employee_code',
        nullable: true
    })
    employeeCode: string;

    @Column('int', {
        name: 'department_name',
        nullable: true
    })
    departmentName: number;

    @Column('int', {
        name: 'division',
        nullable: true
    })
    division: number;

    @Column('varchar', {
        name: 'unit',
        nullable: true
    })
    unit: string;

    @Column('int', {
        name: 'plant_id',
        nullable: true
    })
    plantId: number;

    @Column('int', {
        name: 'role',
        nullable: true
    })
    role: number;

    @Column('varchar', {
        name: 'refNo',
        nullable: true
    })
    refNo: string;

    // @Column('varchar', {
    //     name: 'from',
    //     nullable: true
    // })
    // from: string;

    // @Column('varchar', {
    //     name: 'to',
    //     nullable: true
    // })
    // to: string;

    // @Column('varchar', {
    //     name: 'no_of_people',
    //     nullable: true
    // })
    // noofpeople: string;

    @Column('varchar', {
        name: 'contact_number',
        nullable: true
    })
    contactNumber: string;

    @Column('varchar', {
        name: 'address',
        nullable: true
    })
    address: string;

    @Column('varchar',{
        name: 'gps_location',
        nullable: true
    })
    gpsLocation: string;

    @Column('varchar',{
        name: 'code',
        nullable: true
    })
    code: string;

    @Column('varchar',{
        name: 'access_no',
        nullable: true
    })
    accessNo: string;

    @Column('varchar',{
        name: 'designation',
        nullable: true
    })
    designation: string;

    @Column('varchar',{
        name: 'reporting_head_email_id',
        nullable: true
    })
    reportingHeadEmailId: string;

    @Column('varchar',{
        name: 'email_id',
        nullable: true
    })
    emailId: string;

    @Column('varchar',{
        name: 'factory_code',
        nullable: true
    })
    factoryCode: string;


    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;


}